import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

interface ConfirmDeleteModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    isLoading?: boolean;
    /**
     * Label for the confirm button (e.g. "Kick"). Defaults to "Delete".
     */
    confirmLabel?: string;
    /**
     * Label shown on the confirm button while the action runs; a "..." is
     * appended. Defaults to "Deleting", matching the original wording.
     */
    loadingLabel?: string;
}

/**
 * Reusable confirmation modal for destructive operations (delete, kick, ...).
 */
const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
    show,
    onHide,
    onConfirm,
    title,
    message,
    isLoading = false,
    confirmLabel = 'Delete',
    loadingLabel = 'Deleting',
}) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title className="text-danger">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0">{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={isLoading}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
                    {isLoading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            {`${loadingLabel}...`}
                        </>
                    ) : (
                        confirmLabel
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmDeleteModal;
